
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5338"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5338"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $d804f12f77cac136$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["EN23l","image-tagger.74e0e221.js","2MWcm","logo.65778fdb.png"]'));

// @ts-ignore
var $2c64ba2751beba10$exports = {};
$2c64ba2751beba10$exports = new URL("logo.65778fdb.png", import.meta.url).toString();


const $6a20781988179f23$var$radiansBetweenTwoPoints = (p1, p2)=>Math.atan2(p2.y - p1.y, p2.x - p1.x);
class $6a20781988179f23$var$ImageTagger {
    set selectingHerpes(value) {
        this._selectingHerpes = value;
        // manage overlay
        if (value && this.herpesLocation) {
            console.log(this.herpesLocation);
            this.overlay.style.position = "absolute";
            this.overlay.style.top = (this.herpesLocation.y - 24 - this.size / 2).toString() + "px";
            this.overlay.style.left = (this.herpesLocation.x - 42).toString() + "px";
            this.overlay.style.display = "flex";
        } else this.overlay.style.display = "none";
    }
    get selectingHerpes() {
        return this._selectingHerpes;
    }
    constructor(fileResult){
        this.fileResult = fileResult;
        this.angle = 0;
        this.isRotating = false;
        this.size = 48;
        this.isSizing = false;
        this.isDragging = false;
        this.hoveringHerpes = false;
        this._selectingHerpes = false;
        this.imageContainer = this.getImageContainerOrThrow();
        this.canvasContainer = this.getCanvasContainerOrThrow();
        this.overlay = this.getOverlayOrThrow();
        this.rotate = this.getRotateOrThrow();
        this.sizeElement = this.getSizeElementOrThrow();
    }
    async init() {
        await this.createImage();
        this.createCanvas();
        await this.initLogo();
        this.initRotate();
        this.initSizing();
        this.draw();
    }
    destroy() {
        this.image.remove();
        this.canvas.remove();
    }
    updateText(text) {
        this.text = text;
        this.draw();
    }
    initRotate() {
        this.rotate.addEventListener("mousedown", this.rotateMouseDown.bind(this), false);
    }
    initSizing() {
        this.sizeElement.addEventListener("mousedown", this.sizeMouseDown.bind(this), false);
    }
    async initLogo() {
        if (document.getElementById("logo")) throw new Error("logo already created");
        this.logoImageElement = document.createElement("img");
        this.logoImageElement.id = "logo";
        this.logoImageElement.src = (0, (/*@__PURE__*/$parcel$interopDefault($2c64ba2751beba10$exports)));
        return new Promise((res, rej)=>{
            this.logoImageElement.addEventListener("load", (event)=>{
                res(void 0);
            });
            this.logoImageElement.addEventListener("error", (err)=>{
                rej(err);
            });
        });
    }
    async createImage() {
        if (document.getElementById("image")) throw new Error("image already created");
        this.image = document.createElement("img");
        this.image.id = "image";
        let src = this.fileResult.toString();
        this.image.src = src;
        return new Promise((res, rej)=>{
            this.image.addEventListener("load", (event)=>{
                this.imageContainer.appendChild(this.image);
                res(void 0);
            });
            this.image.addEventListener("error", (err)=>{
                rej(err);
            });
        });
    }
    createCanvas() {
        if (document.getElementById("canvas")) throw new Error("canvas already created");
        this.canvas = document.createElement("canvas");
        this.canvas.id = "canvas";
        this.canvas.width = this.image.width;
        this.canvas.height = this.image.height;
        const mouseUp = this.onMouseUp.bind(this);
        const cursorHandling = this.cursorHandling.bind(this);
        const mouseMove = this.onMouseMove.bind(this);
        const mouseLeave = this.onMouseLeave.bind(this);
        this.canvas.addEventListener("mouseup", (event)=>{
            mouseUp(event);
        }, false);
        this.canvas.addEventListener("mousedown", this.onMouseDown.bind(this), false);
        this.canvas.addEventListener("mousemove", (event)=>{
            mouseMove(event);
            cursorHandling(event);
        }, false);
        this.canvas.addEventListener("mouseleave", (event)=>{
            mouseLeave(event);
        }, false);
        this.canvasContainer.appendChild(this.canvas);
    }
    onMouseDown(event) {
        console.log("onMouseDown", this.getCanvasRelativePositionFromMouseEvent(event));
        if (this.hoveringHerpes) this.isDragging = true;
    }
    onMouseLeave(event) {
        console.log("onMouseLeave", this.getCanvasRelativePositionFromMouseEvent(event));
        document.body.style.cursor = "default";
    }
    onMouseUp(event) {
        console.log("onMouseUp", this.getCanvasRelativePositionFromMouseEvent(event));
        if (this.isRotating) this.isRotating = false;
        if (this.isSizing) this.isSizing = false;
        if (!this.isDragging && !this.herpesLocation) {
            this.addHerpes(event);
            return;
        }
        if (this.hoveringHerpes) this.selectingHerpes = true;
        else this.selectingHerpes = false;
        if (this.isDragging) this.isDragging = false;
    }
    onMouseMove(event) {
        if (!this.herpesLocation) {
            this.hoveringHerpes = false;
            return;
        }
        const mouseLocation = this.getCanvasRelativePositionFromMouseEvent(event);
        if (this.isRotating && this.initialRotatingPosition) {
            this.angle = $6a20781988179f23$var$radiansBetweenTwoPoints(this.initialRotatingPosition, {
                x: event.x,
                y: event.y
            });
            this.draw();
            return;
        }
        if (this.isSizing && this.initialSizePosition) {
            this.size = Math.hypot(this.initialSizePosition.x - event.x, this.initialSizePosition.y - event.y);
            this.draw();
            return;
        }
        if (this.isDragging) {
            this.herpesLocation = {
                x: mouseLocation.x,
                y: mouseLocation.y
            };
            this.draw();
            return;
        }
        this.hoveringHerpes = mouseLocation.x > this.herpesLocation.x - this.size / 2 && mouseLocation.x < this.herpesLocation.x + this.size / 2 && mouseLocation.y > this.herpesLocation.y - this.size / 2 && mouseLocation.y < this.herpesLocation.y + this.size / 2;
    }
    rotateMouseDown(event) {
        this.initialRotatingPosition = {
            x: event.x,
            y: event.y
        };
        this.isRotating = true;
    }
    sizeMouseDown(event) {
        this.initialSizePosition = {
            x: event.x,
            y: event.y
        };
        this.isSizing = true;
    }
    cursorHandling() {
        // cursor handling
        if (!this.herpesLocation) document.body.style.cursor = "pointer";
        else if (this.isDragging) document.body.style.cursor = "grabbing";
        else if (this.hoveringHerpes) document.body.style.cursor = "grab";
        else document.body.style.cursor = "default";
    }
    draw() {
        const context = this.canvas.getContext("2d");
        if (!context) return;
        context?.reset();
        // banner bottom
        const bannerHeight = 164;
        const gradient = context?.createLinearGradient(this.canvas.width / 2, this.canvas.height - bannerHeight, this.canvas.width / 2, this.canvas.height);
        gradient?.addColorStop(0, "rgba(0, 0, 0, 0.69)");
        gradient?.addColorStop(1, "black");
        context.fillStyle = gradient;
        context.fillRect(0, this.canvas.height - bannerHeight, this.canvas.width, bannerHeight);
        // banner logo
        context?.drawImage(this.logoImageElement, this.canvas.width - 128 - 32, this.canvas.height - bannerHeight - 52, 128, 128);
        // text
        if (this.text) {
            let parts = this.text.split(String.fromCharCode(10));
            context.font = "42px Righteous";
            context.fillStyle = "white";
            for(let i = 0; i < parts.length; i++)context.fillText(parts[i], 48, this.canvas.height - bannerHeight + 72 + i * 48);
        }
        if (!this.herpesLocation) return;
        // herpes logo
        context?.translate(this.herpesLocation.x, this.herpesLocation.y);
        context?.rotate(this.angle);
        context?.drawImage(this.logoImageElement, -this.size / 2, -this.size / 2, this.size, this.size);
        context?.rotate(-this.angle);
        context?.translate(-this.herpesLocation.x, -this.herpesLocation.y);
    }
    addHerpes(event) {
        const mouseLocation = this.getCanvasRelativePositionFromMouseEvent(event);
        this.herpesLocation = {
            x: mouseLocation.x,
            y: mouseLocation.y
        };
        this.draw();
    }
    getCanvasRelativePositionFromMouseEvent(event) {
        const canvasRect = this.canvas.getBoundingClientRect();
        const x = event.x - canvasRect.left;
        const y = event.y - canvasRect.top;
        return {
            x: x,
            y: y
        };
    }
    getImageContainerOrThrow() {
        const imgContainer = document.getElementById("image-container");
        if (!imgContainer || !(imgContainer instanceof HTMLDivElement)) throw new Error("image container not found");
        return imgContainer;
    }
    getCanvasContainerOrThrow() {
        const canvasContainer = document.getElementById("canvas-container");
        if (!canvasContainer || !(canvasContainer instanceof HTMLDivElement)) throw new Error("canvas container not found");
        return canvasContainer;
    }
    getOverlayOrThrow() {
        const overlay = document.getElementById("overlay");
        if (!overlay || !(overlay instanceof HTMLDivElement)) throw new Error("overlay not found");
        return overlay;
    }
    getRotateOrThrow() {
        const rotate = document.getElementById("rotate");
        if (!rotate || !(rotate instanceof HTMLElement)) throw new Error("rotate not found");
        return rotate;
    }
    getSizeElementOrThrow() {
        const size = document.getElementById("size");
        if (!size || !(size instanceof HTMLElement)) throw new Error("size not found");
        return size;
    }
    async generatePNG(filename = "hsv.png") {
        if (!this.herpesLocation) {
            console.warn("no herpes location for generate");
            return;
        }
        let canvas = document.createElement("canvas");
        canvas.width = this.image.width;
        canvas.height = this.image.height;
        const context = canvas.getContext("2d");
        if (!context) throw new Error("cannot build context during png generation");
        const img = await new Promise((res, rej)=>{
            const img = document.createElement("img");
            img.src = this.image.src;
            img.addEventListener("load", ()=>{
                res(img);
            });
            img.addEventListener("error", (error)=>{
                rej(error);
            });
        });
        context.drawImage(img, 0, 0);
        // banner bottom
        const bannerHeight = 164;
        const gradient = context?.createLinearGradient(this.canvas.width / 2, this.canvas.height - bannerHeight, this.canvas.width / 2, this.canvas.height);
        gradient?.addColorStop(0, "rgba(0, 0, 0, 0.69)");
        gradient?.addColorStop(1, "black");
        context.fillStyle = gradient;
        context.fillRect(0, this.canvas.height - bannerHeight, this.canvas.width, bannerHeight);
        // banner logo
        context?.drawImage(this.logoImageElement, this.canvas.width - 128 - 32, this.canvas.height - bannerHeight - 52, 128, 128);
        // text
        if (this.text) {
            let parts = this.text.split(String.fromCharCode(10));
            context.font = "42px Righteous";
            context.fillStyle = "white";
            for(let i = 0; i < parts.length; i++)context.fillText(parts[i], 48, this.canvas.height - bannerHeight + 72 + i * 48);
        }
        context.translate(this.herpesLocation.x, this.herpesLocation.y);
        context.rotate(this.angle);
        context.drawImage(this.logoImageElement, -this.size / 2, -this.size / 2, this.size, this.size);
        context.rotate(-this.angle);
        context.translate(-this.herpesLocation.x, -this.herpesLocation.y);
        canvas.toBlob((blob)=>{
            if (blob === null) return;
            let data = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.href = data;
            link.download = filename;
            link.click();
        }, "image/png");
        img.remove();
        canvas.remove();
    }
}
let $6a20781988179f23$var$file;
let $6a20781988179f23$var$fileResult = null;
let $6a20781988179f23$var$imageTagger = null;
const $6a20781988179f23$var$step2 = async ()=>{
    if (!$6a20781988179f23$var$fileResult) throw new Error("upload image first");
    const containerStep2 = document.querySelector("#container-step2");
    if (!containerStep2 || !(containerStep2 instanceof HTMLDivElement)) throw new Error("cannot find container step 2");
    containerStep2.style.display = "flex";
    $6a20781988179f23$var$imageTagger = new $6a20781988179f23$var$ImageTagger($6a20781988179f23$var$fileResult);
    await $6a20781988179f23$var$imageTagger.init();
    const input = document.getElementById("input");
    input?.addEventListener("input", async (event)=>{
        if (!(event.target instanceof HTMLTextAreaElement)) return;
        const text = event.target.value.trim();
        $6a20781988179f23$var$imageTagger?.updateText(text);
    });
    const nextButton = document.getElementById("next");
    if (!nextButton || !(nextButton instanceof HTMLButtonElement)) throw new Error("cannot find button next step2");
    const onButtonClicked = async ()=>{
        await $6a20781988179f23$var$imageTagger?.generatePNG();
    };
    nextButton.addEventListener("click", onButtonClicked);
    const resetButton = document.getElementById("reset");
    if (!resetButton || !(resetButton instanceof HTMLButtonElement)) throw new Error("cannot find button reset step2");
    const onResetClicked = async ()=>{
        $6a20781988179f23$var$imageTagger?.destroy();
        nextButton.removeEventListener("click", onButtonClicked);
        resetButton.removeEventListener("click", onResetClicked);
        containerStep2.style.display = "none";
        const containerStep1 = document.querySelector("#container-step1");
        if (!containerStep1 || !(containerStep1 instanceof HTMLDivElement)) throw new Error("cannot find container step 1");
        containerStep1.style.display = "flex";
        containerStep1.style.display = "flex";
    };
    resetButton.addEventListener("click", onResetClicked);
};
const $6a20781988179f23$var$step1 = async ()=>{
    const containerStep1 = document.querySelector("#container-step1");
    if (!containerStep1 || !(containerStep1 instanceof HTMLDivElement)) throw new Error("cannot find container step 1");
    containerStep1.style.display = "flex";
    const dropArea = document.querySelector(".drag-area");
    const dragText = document.querySelector(".header");
    if (!dropArea || !(dropArea instanceof HTMLDivElement) || !dragText) throw new Error("cannot find drag area and/or header");
    const button = document.getElementById("upload-button");
    const input = dropArea.querySelector("input");
    if (!input) throw new Error("cannot find file upload input");
    if (!button || !(button instanceof HTMLSpanElement)) throw new Error("cannot find upload button");
    const processFile = ()=>{
        let fileType = $6a20781988179f23$var$file.type;
        let validExtensions = [
            "image/jpeg",
            "image/jpg",
            "image/png"
        ];
        if (validExtensions.includes(fileType)) {
            let fileReader = new FileReader();
            fileReader.onload = ()=>{
                $6a20781988179f23$var$fileResult = fileReader.result;
                containerStep1.style.display = "none";
                $6a20781988179f23$var$step2();
            };
            fileReader.readAsDataURL($6a20781988179f23$var$file);
        } else {
            alert("This is not an Image File");
            dropArea.classList.remove("active");
        }
    };
    input.addEventListener("change", function(event) {
        const target = event.target;
        if (!target || !(target instanceof HTMLInputElement)) throw new Error("cannot find file upload input");
        const firstFile = target.files?.[0];
        if (!firstFile) {
            console.warn("no file selected");
            return;
        }
        $6a20781988179f23$var$file = firstFile;
        dropArea.classList.add("active");
        processFile();
    });
    dropArea.addEventListener("dragover", (event)=>{
        event.preventDefault();
        dropArea.classList.add("active");
        dragText.textContent = "Release to Upload";
    });
    dropArea.addEventListener("dragleave", ()=>{
        dropArea.classList.remove("active");
        dragText.textContent = "Drag & Drop";
    });
    dropArea.addEventListener("drop", (event)=>{
        event.preventDefault();
        const firstFile = event.dataTransfer?.files?.[0];
        if (!firstFile) {
            console.warn("no file selected");
            dropArea.classList.remove("active");
            return;
        }
        $6a20781988179f23$var$file = firstFile;
        dropArea.classList.add("active");
        processFile();
    });
    button.onclick = ()=>{
        input.click();
    };
};
const $6a20781988179f23$var$boot = async ()=>{
    $6a20781988179f23$var$step1();
};
document.addEventListener("DOMContentLoaded", function() {
    $6a20781988179f23$var$boot();
});


//# sourceMappingURL=image-tagger.74e0e221.js.map
